<script>
export default {
    name: "ViewImagingResults",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    props: {

        showModal: Boolean,
        imageResults: Array,
        results: Object,
        investigation: Object,
    },

    methods: {

        printImagingResult() {

            window.open(`/medical-file/imaging-result/print/${this.$route.params.patientID}/${this.investigation.code}`, '_blank', `LabResultPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-base">Imaging Request</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <div class="w-full flex flex-wrap p-1 bg-gray-300 my-1">
                <div class="md:w-1/3 sm:w-1/2">
                    <h5 class="text-sm"><span class="font-medium">Investigation:</span> {{ investigation.investigation }}</h5>
                </div>
                <div class="md:w-1/3 sm:w-1/2">
                    <h5 class="text-sm"><span class="font-medium">Requested By:</span> {{ investigation.requestedBy || `-` }}</h5>
                </div>
                <div class="md:w-1/3 sm:w-1/2">
                    <h5 class="text-sm"><span class="font-medium">Done:</span> {{ investigation.done ? `Yes` : `No` }}</h5>
                </div>
            </div>
            <ul class="flex border-b-2 border-gray-500">
              <li class="-mb-px mr-1">
                  <a href="javascript:void(0)" @click.prevent="active=0" 
                    class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                    :class="active == 0 ? activeClass : inActiveClass">Component Results</a>
              </li>
              <li class="-mb-px mr-1">
                  <a href="javascript:void(0)" @click.prevent="active=1"
                    class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                    :class="active == 1 ? activeClass : inActiveClass">Images</a>
              </li>
            </ul>
            <div class="w-full" v-if="active==0">
                <div class="w-full overflow-auto bg-white" style="max-height:50vh;">
                    <span v-html="investigation.resultsMemo"></span>
                </div>
            </div>
            <div class="w-full" v-if="active==1">
                <div class="w-full flex flex-col">
                    <div class="flex-1 p-tiny" v-for="(result, idx) in imageResults" :key="idx">
                      <h5 class="mb-2 font-medium text-base capitalize">{{ result.comment }}</h5>
                      <iframe height="1300" width="1400" :src="`data:application/pdf;base64,${result.investigationImage}`"></iframe>
                    </div>
                </div>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-primary btn-sm text-xs rounded mr-8" 
            @click.prevent="printImagingResult"><i class="fa fa-print"></i> Print
        </button>
        <button 
            class="btn-danger btn-sm text-xs rounded" 
            @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Close
        </button>
      </template>
    </tail-modal>
</template>